// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"283ab0b3","453":"00d824e4"}[chunkId] + ".chunk.js";
};